import { captureMessage } from '@sentry/browser';
import { axios } from 'utils/axios';
import {
  SmartCollectionInput,
  SmartCollectionResponse,
  isSmartCollectionInputWithSlug,
} from './types';
import { cleanUpInput, isSmartCollectionResponse } from './utils';

/**
 * Fetch collection using Smart Collection API.
 * Returns personalized product recommendations based on input parameters and audience targeting.
 */
export const getSmartCollection = async (
  input: SmartCollectionInput
): Promise<SmartCollectionResponse> => {
  let audiences: undefined | string | number | boolean;

  const result = await axios
    .post<SmartCollectionResponse>(
      '/api/legacy/smart-collections',
      {
        ...cleanUpInput(input),
      },
      { isPdexApi: true }
    )
    .then((data) => {
      audiences = data.config.headers && data.config.headers['audiences'];
      return data;
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw new Error(
        `Smart Collection API request failed: ${error.message}. Input: ${JSON.stringify(
          cleanUpInput(input)
        )}`
      );
    });

  if (!result) {
    throw new Error(
      `Smart Collection API returned empty response for input: ${JSON.stringify(
        cleanUpInput(input)
      )}`
    );
  }

  if (isSmartCollectionResponse(result) && result.items.length === 0) {
    const slug = isSmartCollectionInputWithSlug(input) ? input.slug : 'no-slug';
    captureMessage(
      `Smart Collection API returned empty items array for slug: ${slug}`,
      {
        level: 'debug',
        extra: {
          input: cleanUpInput(input),
          audiences: audiences,
          endpoint: '/api/legacy/smart-collections',
        },
      }
    );
  }

  return result;
};
